import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestPostosPlanejamento({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'postoplanejamento', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deletePostoPlanejamento({ payload }) {
  try {
    const { idpostoplanejamento, params } = payload;

    yield call(api.delete, `postoplanejamento/${idpostoplanejamento}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { postoplanejamento, params } = payload;

    yield call(api.post, 'postoplanejamento', postoplanejamento);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/postoplanejamentocliente');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idpostoplanejamento } = payload;

    const { data } = yield call(
      api.get,
      `postoplanejamento/${idpostoplanejamento}`
    );
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { postoplanejamento, params } = payload;

    yield call(api.put, 'postoplanejamento', postoplanejamento);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/postoplanejamentocliente');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'postoplanejamento', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@postoplanejamento/POSTOSPLANEJAMENTO_IN_REQUEST',
    requestPostosPlanejamento
  ),
  takeLatest(
    '@postoplanejamento/DELETE_POSTOPLANEJAMENTO',
    deletePostoPlanejamento
  ),
  takeLatest('@postoplanejamento/SUCCESS_REMOVE', requestPostosPlanejamento),
  takeLatest('@postoplanejamento/STORE_POSTOPLANEJAMENTO', store),
  takeLatest('@postoplanejamento/FIND_POSTOPLANEJAMENTO', find),
  takeLatest('@postoplanejamento/UPDATE_POSTOPLANEJAMENTO', update),
  takeLatest('@postoplanejamento/RECORD_FILTERING', applyedFilters),
]);
